/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { AnyAction } from '@reduxjs/toolkit';
import * as actionTypes from '../constants/action-types';

export type AuthenticationTokenState = { loaded: true, token: string } | { loaded: false, token: undefined }
const defaultState: AuthenticationTokenState = { token: undefined, loaded: false };

const authenticationToken = (state: AuthenticationTokenState = defaultState, action: AnyAction): AuthenticationTokenState => {
  switch (action.type) {
    case actionTypes.AUTHENTICATION_TOKEN_LOADED:
      return { ...state, loaded: true, token: action.token }
    case actionTypes.AUTHENTICATION_TOKEN_UNLOADED:
      return { ...state, loaded: false, token: undefined }
    default:
      return state;
  }
}

export default authenticationToken;
